import { i18n } from "translations";

import {
  ApprovalWorkFlowData,
  ApprovalWorkFlowNextAction,
  ApprovalWorkFlowType,
} from "./types";

export const ApprovalWorkFlowList = [
  ApprovalWorkFlowData.PAYROLL_SHEET,
  ApprovalWorkFlowData.PAYROLL_UNLOCK,
  ApprovalWorkFlowData.OT,
  ApprovalWorkFlowData.LEAVE,
  ApprovalWorkFlowData.SUMMARY_PRODUCTIVITY_SALARY,
  ApprovalWorkFlowData.PRODUCTIVITY_SALARY,
  ApprovalWorkFlowData.SALARY_13TH_MONTH,
  ApprovalWorkFlowData.KPI_INDIVIDUAL,
  ApprovalWorkFlowData.KPI_DEPARTMENT,
];

export const ApprovalWorkFlowCategoryOptions = [
  {
    label: i18n.t("payrollApproval"),
    value: ApprovalWorkFlowData.PAYROLL_SHEET,
  },
  {
    label: i18n.t("otApproval"),
    value: ApprovalWorkFlowData.OT,
  },
  {
    label: i18n.t("leaveApproval"),
    value: ApprovalWorkFlowData.LEAVE,
  },
  {
    label: i18n.t("salaryAdvance"),
    value: ApprovalWorkFlowData.SALARY_ADVANCE,
  },
  {
    label: i18n.t("paySalary"),
    value: ApprovalWorkFlowData.SALARY_PAYMENT,
  },
  {
    label: i18n.t("productivitySalarySummaryApproval"),
    value: ApprovalWorkFlowData.SUMMARY_PRODUCTIVITY_SALARY,
  },
  {
    label: i18n.t("productivitySalaryApproval"),
    value: ApprovalWorkFlowData.PRODUCTIVITY_SALARY,
  },
  {
    label: i18n.t("salary13thMonthApproval"),
    value: ApprovalWorkFlowData.SALARY_13TH_MONTH,
  },
  {
    label: i18n.t("individualKpiRewardSheetApproval"),
    value: ApprovalWorkFlowData.KPI_INDIVIDUAL,
  },
  {
    label: i18n.t("departmentKpiRewardSheetApproval"),
    value: ApprovalWorkFlowData.KPI_DEPARTMENT,
  },
];

export const ApprovalWorkFlowTypeOptions = [
  {
    label: i18n.t("ONE"),
    value: ApprovalWorkFlowType.ONE,
  },
  {
    label: i18n.t("ALL"),
    value: ApprovalWorkFlowType.ALL,
  },
];

export const ApprovalWorkFlowNextActionOptions = [
  {
    label: i18n.t("autoApproval"),
    value: ApprovalWorkFlowNextAction.AUTO_APPROVE,
  },
  {
    label: i18n.t("autoReject"),
    value: ApprovalWorkFlowNextAction.AUTO_REJECT,
  },
  {
    label: i18n.t("remindApproved"),
    value: ApprovalWorkFlowNextAction.REMIND,
  },
];
